

import urlBuilder from "app/umbraco/helpers/urlBuilder";
import imageData from "./imageData";

type Size = { desktop: number; tablet: number; mobile: number };

const setImageOptionsSrc = (src: string, width: Size, height: Size): string[] => {
    if (!src) return [];

    const imageUrl = src.startsWith("http") ? src : urlBuilder(src);
    const params = new URLSearchParams();

    const calculateSize = (size: Size, device: string): number => {
        return size[device];
    };

    const imageUrlsWithOptions = imageData.map((data) => {
        const imageWidth = width ? calculateSize(width, data.device) : data.width * data.multiplier;
        const imageHeight = calculateSize(height, data.device);

        params.set("width", `${imageWidth}`);
        params.set("height", `${imageHeight}`);

        // Image Focal Point Params
        params.set("rxy", `${0.5},${0.5}`);

        params.set("quality", "95");

        if (data.type === "image/webp") {
            params.set("format", "webp");
        } else {
            params.delete("format");
        }
        const querySeparator = imageUrl.toString().indexOf("?") > 0 ? "&" : "?";
        return `${imageUrl}${querySeparator}${params.toString()}`;
    });

    return imageUrlsWithOptions;
};

export default setImageOptionsSrc;
